import {computed, Injectable, signal} from '@angular/core';
import {BackdropConfig, BackdropSource} from '@app/core/types/backdrop-config.interface';


@Injectable({
  providedIn: 'root'
})
export class BackdropService {
  private readonly items = signal<BackdropConfig[]>([]);

  readonly activeItem = computed(() => {
    const list = this.items();
    return list.length > 0 ? list[list.length - 1] : null;
  });

  readonly isOpen = computed(() => {
    return this.activeItem() !== null;
  });

  open(config: BackdropConfig): void {
    this.items.update((items) => {
      const filtered = items.filter((item) => item.source !== config.source);

      return [
        ...filtered,
        {
          closeOnClick: true,
          hideOnDesktop: false,
          ...config,
        },
      ];
    });
  }

  close(source: BackdropSource): void {
    this.items.update((items) => {
      return items.filter((item) => item.source !== source);
    });
  }

  closeAll(): void {
    this.items.set([]);
  }

  backdropClick(): void {
    const active = this.activeItem();

    if (!active) {
      return;
    }

    active.onClick?.();

    if (active.closeOnClick) {
      this.close(active.source);
    }
  }
}
